import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoGooglePlus = () => {
  return (
    <g>
      <path d="m5.1407 7.2852v1.7155h2.8379a2.7022 2.7022 0 0 1 -2.8379 2.1593 3.16 3.16 0 0 1 0-6.319 2.8159 2.8159 0 0 1 1.9943.772l1.3582-1.3086a4.7965 4.7965 0 0 0 -3.3525-1.3081 5.0037 5.0037 0 1 0 0 10.0075 4.6155 4.6155 0 0 0 4.8036-4.8894 4.6022 4.6022 0 0 0 -.0786-.8292z" />
      <path d="m15.863 7.285h-1.43v-1.429h-1.429v1.429h-1.43v1.43h1.43v1.429h1.429v-1.429h1.43z" />
    </g>
  );
};

export default withIcon(IconLogoGooglePlus);
